import React, { useState } from 'react';
import './VariableInserter.css';

const VARIABLE_CATEGORIES = {
  contact: {
    label: 'Contact',
    variables: [
      { key: 'contact.name', label: 'Contact Name', example: 'John Doe' },
      { key: 'contact.email', label: 'Contact Email', example: 'john@example.com' },
      { key: 'contact.firstName', label: 'First Name', example: 'John' },
      { key: 'contact.lastName', label: 'Last Name', example: 'Doe' },
      { key: 'contact.outlet', label: 'Outlet/Publication', example: 'Rolling Stone' },
      { key: 'contact.type', label: 'Contact Type', example: 'DJ' },
    ],
  },
  release: {
    label: 'Release',
    variables: [
      { key: 'release.title', label: 'Release Title', example: 'My New Album' },
      { key: 'release.artist', label: 'Artist Name', example: 'Artist Name' },
      { key: 'release.label', label: 'Label', example: 'Record Label' },
      { key: 'release.releaseDate', label: 'Release Date', example: '2026-01-18' },
      { key: 'release.artwork.url', label: 'Artwork URL', example: 'https://...' },
      { key: 'release.genre', label: 'Genre', example: 'Electronic' },
    ],
  },
  campaign: {
    label: 'Campaign',
    variables: [
      { key: 'campaign.subject', label: 'Subject Line', example: 'Check out my new release!' },
      { key: 'downloadUrl', label: 'Download Link', example: 'https://...' },
      { key: 'trackingPixelUrl', label: 'Tracking Pixel', example: 'https://...' },
      { key: 'unsubscribeUrl', label: 'Unsubscribe Link', example: 'https://...' },
    ],
  },
  conditionals: {
    label: 'Conditionals & Loops',
    variables: [
      { key: '#if', label: 'If Statement', example: '{{#if variable}}...{{/if}}', isBlock: true },
      { key: '#unless', label: 'Unless Statement', example: '{{#unless variable}}...{{/unless}}', isBlock: true },
      { key: '#each', label: 'Loop (Each)', example: '{{#each items}}...{{/each}}', isBlock: true },
      { key: 'else', label: 'Else', example: '{{else}}', isBlock: true },
    ],
  },
};

const VariableInserter = ({ onInsert, targetField }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('contact');
  const [searchQuery, setSearchQuery] = useState('');

  const handleInsert = (variable) => {
    let insertText;

    if (variable.isBlock) {
      // For block helpers, insert the full syntax
      insertText = variable.example;
    } else {
      // For regular variables, wrap in double curly braces
      insertText = `{{${variable.key}}}`;
    }

    onInsert(insertText);
    setIsOpen(false);
    setSearchQuery('');
  };

  const filteredVariables = () => {
    if (!searchQuery) {
      return VARIABLE_CATEGORIES[activeCategory].variables;
    }

    return VARIABLE_CATEGORIES[activeCategory].variables.filter(
      (v) =>
        v.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.key.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  return (
    <div className="variable-inserter">
      <button
        type="button"
        className="insert-variable-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        Insert Variable
      </button>

      {isOpen && (
        <div className="variable-inserter-dropdown">
          <div className="variable-inserter-header">
            <input
              type="text"
              placeholder="Search variables..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="variable-search"
            />
          </div>

          <div className="variable-inserter-body">
            <div className="variable-categories">
              {Object.entries(VARIABLE_CATEGORIES).map(([key, category]) => (
                <button
                  key={key}
                  type="button"
                  className={`category-btn ${activeCategory === key ? 'active' : ''}`}
                  onClick={() => {
                    setActiveCategory(key);
                    setSearchQuery('');
                  }}
                >
                  {category.label}
                </button>
              ))}
            </div>

            <div className="variable-list">
              {filteredVariables().map((variable) => (
                <button
                  key={variable.key}
                  type="button"
                  className="variable-item"
                  onClick={() => handleInsert(variable)}
                >
                  <div className="variable-item-header">
                    <span className="variable-label">{variable.label}</span>
                    <code className="variable-code">
                      {variable.isBlock ? variable.example : `{{${variable.key}}}`}
                    </code>
                  </div>
                  <div className="variable-example">
                    Example: {variable.example}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariableInserter;
